import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import MarketShell from '../components/market/MarketShell';
import { fetchMarketCards } from '../lib/marketCatalog';
import { useFavorites } from '../lib/marketFavorites';
import { CardRow } from './MarketHome';

// Favorites (/market/favorites) — the signed-in visitor's own list, kept in
// the database (market_favorites; RLS: own rows only). A product staff hid or
// that is no longer listed simply drops out of the page; the row is kept.

const T = {
  ar: { title: 'المفضلة', empty: 'لم تضف منتجات إلى المفضلة بعد.', browse: 'تصفح السوق', signIn: 'سجّل الدخول لعرض مفضلتك.', login: 'تسجيل الدخول', back: 'السوق' },
  en: { title: 'Favorites', empty: 'You have no favorites yet.', browse: 'Browse the market', signIn: 'Sign in to see your favorites.', login: 'Sign in', back: 'Market' },
  zh: { title: '收藏', empty: '您还没有收藏商品。', browse: '浏览市场', signIn: '请登录查看收藏。', login: '登录', back: '市场' },
};

export default function MarketFavorites({ lang = 'ar', user, exchangeRates }) {
  const nav = useNavigate();
  const c = T[lang] || T.ar;
  const isAr = lang === 'ar';
  const font = isAr ? 'var(--font-ar)' : 'var(--font-sans)';
  usePageTitle('market', lang);
  const fav = useFavorites(user?.id);
  const key = [...fav.ids].join(',');
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!user) { setRows([]); return; }
    fetchMarketCards(key ? key.split(',') : []).then((r) => setRows(r.rows));
  }, [key, user]);
  const btn = { padding: '9px 18px', borderRadius: 12, border: 'none', background: '#1A1814', color: '#fff', cursor: 'pointer', fontFamily: font, fontSize: 14 };
  return (
    <MarketShell lang={lang} user={user}>
      <div className="mk-wrap" style={{ paddingTop: 20, paddingBottom: 48 }}>
        <button className={`fx-back${isAr ? ' ar' : ''}`} onClick={() => nav('/market')}>{isAr ? '→ ' : '← '}{c.back}</button>
        <h1 className={`fx-h1${isAr ? ' ar' : ''}`}>{c.title}</h1>
        {!user ? (
          <div data-favorites-signin="1" style={{ fontFamily: font }}><p className="fx-sub">{c.signIn}</p>
            <button type="button" style={btn} onClick={() => nav(`/login?next=${encodeURIComponent('/market/favorites')}`)}>{c.login}</button></div>
        ) : rows === null ? <p>…</p> : rows.length === 0 ? (
          <div data-favorites-empty="1" style={{ fontFamily: font }}><p className="fx-sub">{c.empty}</p><button type="button" style={btn} onClick={() => nav('/market')}>{c.browse}</button></div>
        ) : <CardRow rows={rows} lang={lang} user={user} exchangeRates={exchangeRates} max={rows.length} />}
      </div>
    </MarketShell>
  );
}
